import { formatDate } from '@clatter/platform';
import React, { FC } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface TemplateLabelProps {
  name: string;
  previewLink?: string;
  lastUpdated?: string;
  noMargin?: boolean;
  children?: React.ReactNode;
}

const StyledContainer = styled.div`
  padding: ${({ theme }) => `${theme.spacing.small} 0`};
  text-align: left;
  vertical-align: middle;

  h4 {
    margin-bottom: ${({ theme }) => theme.spacing.small};

    &.no-margin {
      margin-bottom: 0;
    }
  }

  &.hoverable {

    a {
      display: flex;
      gap: ${({ theme }) => theme.spacing.small};


      .icon {
        opacity: 0;

        svg {
          font-size: ${({ theme }) => theme.fontSize.default};
        }
      }
    }

    &:hover {
      h4 {
        text-decoration: underline;
        cursor: pointer;
      }

      a {
        color: ${({ theme }) => theme.palette.linkHoverColor};
      }

      .icon {
        opacity: 1;
      }
    }
  }
`;
export const TemplateLabel: FC<TemplateLabelProps> = ({ children, previewLink, name, lastUpdated, noMargin = false }) => {
  return (
    <StyledContainer className={classNames({ hoverable: !!previewLink })}>
      {previewLink ? (
        <a href={previewLink} target="_blank" rel="noopener noreferrer">
          <h4>{name}</h4>
          <span className="icon"><OpenInNewIcon /></span>
        </a>
      ) : (
        <h4 className={classNames({ 'no-margin': noMargin })}>{name}</h4>
      )}
      {lastUpdated && <small>{formatDate(lastUpdated)}</small>}
      { children }
    </StyledContainer>
  );
};
